import { ChakraProvider, theme } from "@chakra-ui/react";
import {
  AnalyticsProvider,
  createQueryClient,
  EhrProvider,
  PatientConsolidatedStateProvider,
  PreviewPatientOverview,
  PreviewPatientOverviewV2,
  QueryClientProvider,
  ShadowDOMProvider,
} from "@metriport/shared-internal";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import * as Sentry from "@sentry/react";

// https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/#usage-with-react-router-64-data-api
const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

const queryClient = createQueryClient();

export const App = () => {
  return (
    <main>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ChakraProvider theme={theme}>
            <AnalyticsProvider>
              <PatientConsolidatedStateProvider>
                <SentryRoutes>
                  <Route path="/" element={<PreviewPatientOverview />} />
                  <Route
                    path="/v2"
                    element={
                      <EhrProvider patientId="">
                        <ShadowDOMProvider>
                          <PreviewPatientOverviewV2 />
                        </ShadowDOMProvider>
                      </EhrProvider>
                    }
                  />
                </SentryRoutes>
              </PatientConsolidatedStateProvider>
            </AnalyticsProvider>
          </ChakraProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </main>
  );
};
